module.exports = "<div class=\"widget\" *ngIf=\"loggedIn\">\r\n  <h3>Campfire</h3>\r\n</div>\r\n"